import React from 'react'
import styled from 'styled-components'

export const ImageWrapper = styled.div`
  @media (min-width: 768px) {
    height: 250px;
  }
  @media (min-width: 1024px) {
    height: 335px;
  }
  @media (min-width: 1280px) {
    height: 420px;
  }
`